// extracted by mini-css-extract-plugin
export default {"app":"App_app__4xG+3","content":"App_content__kwxhx","outlet":"App_outlet__x2BmF"};